import { BannerId, TurbolandingId, TurbolandingPage } from '../../typings/banners';

export const GET_TURBOLANDING_INFO_FOR_SITELINK = 'GET_TURBOLANDING_INFO_FOR_SITELINK';
export const UPDATE_TURBOLANDING_INFO_FOR_SITELINK = 'UPDATE_TURBOLANDING_INFO_FOR_SITELINK';
export const SHOW_TURBOLANDING_INFO_FOR_SITELINK_ERROR = 'SHOW_TURBOLANDING_INFO_FOR_SITELINK_ERROR';

export type GET_TURBOLANDING_INFO_FOR_SITELINK = typeof GET_TURBOLANDING_INFO_FOR_SITELINK;
export type UPDATE_TURBOLANDING_INFO_FOR_SITELINK = typeof UPDATE_TURBOLANDING_INFO_FOR_SITELINK;
export type SHOW_TURBOLANDING_INFO_FOR_SITELINK_ERROR = typeof SHOW_TURBOLANDING_INFO_FOR_SITELINK_ERROR;

export interface GetTurbolandingInfoForSitelink {
    type: GET_TURBOLANDING_INFO_FOR_SITELINK;
    bannerId: BannerId;
    landingId: TurbolandingId;
}
export function getTurbolandingInfoForSitelink(
    bannerId: BannerId,
    landingId: TurbolandingId
): GetTurbolandingInfoForSitelink {
    return {
        type: GET_TURBOLANDING_INFO_FOR_SITELINK,
        landingId,
        bannerId
    };
}

export interface UpdateTurbolandingForSitelink {
    type: UPDATE_TURBOLANDING_INFO_FOR_SITELINK;
    bannerId: BannerId;
    index: number;
    landing: TurbolandingPage;
}
export function updateTurbolandingForSitelink(
    bannerId: BannerId,
    index: number,
    landing: TurbolandingPage
): UpdateTurbolandingForSitelink {
    return {
        type: UPDATE_TURBOLANDING_INFO_FOR_SITELINK,
        bannerId,
        index,
        landing
    };
}

export type TurbolandingActions = GetTurbolandingInfoForSitelink | UpdateTurbolandingForSitelink;
